module.exports = __webpack_public_path__ + "static/img/login_center_bg.5307896.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login_center_bg.png
// module id = hNpR
// module chunks = 34